import React from "react";
import { Link } from "react-router-dom";

const Banner = ({ imagePath, BannerText }) => {
  return (
    <>
      <div
        className=" position-relative max-height-400"
        data-aos="fade-in"
        style={{
          overflow: "hidden",
        }}
      >
        <img src={`/images/Banners/${imagePath}`} width={"100%"} />
        <section className="mask bg-secondry-dark d-flex text-center align-items-center justify-content-center">
          <span className="h1 text-white ">{BannerText}</span>
        </section>
      </div>
      <div className="container py-3">
        <nav aria-label="breadcrumb">
          <ol
            className="breadcrumb"
            style={{
              backgroundColor: "transparent !important",
            }}
          >
            <li className="breadcrumb-item">
              <Link to="/">
                <i className="fas fa-home"></i>
              </Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              {BannerText}
            </li>
          </ol>
        </nav>
      </div>
    </>
  );
};

export default Banner;
